import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updatedMoney } from '../slices/WalletSlice';
import { BASE_API } from '../helper/Constants';

const SSEListener = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.wallet.userId);

  useEffect(() => {
    if (!userId) return;

    const eventSource = new EventSource( BASE_API+ 'api/balance-updates/'+userId);

    eventSource.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.userId === userId) {
        dispatch(updatedMoney(data.balance));
      }
    };

    eventSource.onerror = (error) => {
      console.error('SSE error:', error);
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [dispatch, userId]);

  return null; // This component doesn't render anything
};

export default SSEListener;